import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';

@Component({
  selector: 'app-knet',
  templateUrl: './knet.page.html',
  styleUrls: ['./knet.page.scss'],
})
export class KnetPage implements OnInit {

  constructor(private service: ServicesProvider, private route: Router) { }

  async ngOnInit() {
    let searchParams = new URLSearchParams(window.location.search);
    let resultValue = searchParams.get('result');
    const decryptKey = "NX706H5HECB8W336"
    if (resultValue && resultValue != "") {
      resultValue = resultValue.replace(/p1L2u3S/g, '+').replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=')
      let response_data: any = this.decrypt(resultValue, decryptKey);
      if (response_data != "") {
        response_data = response_data.split("&")
        const dataObj: any = {};
        response_data.forEach((pair: any) => {
          const [key, value] = pair.split('=');
          dataObj[key] = value;
        });

        localStorage.setItem("paymentResult", dataObj.result)
        if (dataObj.result == "CAPTURED") {
          let requestdata = {
            paymentid: dataObj['paymentid'],
            result: dataObj['result'],
            auth: dataObj['auth'],
            avr: dataObj['avr'],
            ref: dataObj['ref'],
            tranid: dataObj['tranid'],
            postdate: dataObj['postdate'],
            trackid: dataObj['trackid'],
            udf1: dataObj['udf1'],
            udf2: dataObj['udf2'],
            udf3: dataObj['udf3'],
            udf4: dataObj['udf4'],
            udf5: dataObj['udf5'],
            amt: dataObj['amt']
          }
          try {
            const response = await this.service.postRequest("knetPaymentTransactions", requestdata).subscribe((res) => {
              if (res.status == 1) {
                localStorage.setItem('paymentstatus', 'completed');
                localStorage.setItem('resultindicator', dataObj['paymentid']);
                localStorage.setItem('referenceid', dataObj['tranid']);
                localStorage.setItem('paymentGatewayName', "KNET");
                localStorage.setItem('paymentAmt', dataObj['amt']);
                localStorage.setItem('paymentObject', JSON.stringify(dataObj));
                const vendorTypeId = localStorage.getItem('VendorType')
                const bookingId = localStorage.getItem('bookindId')
                if (vendorTypeId == "10") {
                  window.location.href = window.location.origin + "/tabs/booking-room?id=" + bookingId;
                } else if (vendorTypeId == "5") {
                  this.route.navigate(['/tabs/nursing']);
                  // window.location.href = window.location.origin + "/tabs/nursing?id=" + bookingId;
                } else if (vendorTypeId == "8") {
                  window.location.href = window.location.origin + "/tabs/dietmeal?id=" + bookingId;
                }
              }
            })
          } catch (error) {
            console.error(error);
          }
        }
        else {
          localStorage.setItem('paymentstatus', 'failed');
          localStorage.setItem('resultindicator', dataObj['paymentid']);
          localStorage.setItem('referenceid', dataObj['tranid']);
          localStorage.setItem('paymentGatewayName', "KNET");
          localStorage.setItem('paymentObject', JSON.stringify(dataObj));
          const vendorTypeId = localStorage.getItem('VendorType')
          const bookingId = localStorage.getItem('bookindId')
          if (vendorTypeId == "10") {
            window.location.href = window.location.origin + "/tabs/booking-room?id=" + bookingId;
          } else if (vendorTypeId == "5") {
            // this.route.navigate(['/tabs/nursing']);
            window.location.href = window.location.origin + "/tabs/nursing?id=" + bookingId;
          } else if (vendorTypeId == "8") {
            window.location.href = window.location.origin + "/tabs/dietmeal?id=" + bookingId;
          }
        }
      }
      else {
        console.log("ks");
      }
    }
    else {
      console.log("ks");
    }
  }

  decrypt(data, termResourceKey) {
    const decodedData = atob(data);
    let result = '';
    const keyLength = termResourceKey.length;
    for (let i = 0; i < decodedData.length; i++) {
      const char = decodedData[i];
      const keyChar = termResourceKey[i % keyLength];
      result += String.fromCharCode(char.charCodeAt(0) - keyChar.charCodeAt(0));
    }
    return result;
  }

}
